// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"66b69cf6","120":"3899bba6","262":"184e98cb","327":"dc50a428","390":"ba449c97","652":"5ad28c11","787":"cf6a0b8b","792":"adf22b25"}[chunkId] + ".chunk.js";
};